import {
    createContext,
    useContext,
    useState,
    PropsWithChildren,
    useMemo
} from "react";

import { TemplateData } from "../site-selector-modal/site-selector-context";

const ProductTemplateContext = createContext<{
    template: TemplateData | null;
    setTemplate: (template: TemplateData | null) => void;
}>({
    template: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setTemplate: () => {}
});

export const ProductTemplateContextProvider = ({
    children
}: PropsWithChildren) => {
    const [template, setTemplate] = useState<TemplateData | null>(null);

    const value = useMemo(() => ({ template, setTemplate }), [template]);

    return (
        <ProductTemplateContext.Provider value={value}>
            {children}
        </ProductTemplateContext.Provider>
    );
};

export const useProductTemplateContext = () => {
    const context = useContext(ProductTemplateContext);
    if (!context) {
        throw new Error(
            "useProductTemplateContext must be used within a ProductTemplateContextProvider"
        );
    }
    return context;
};

export default ProductTemplateContextProvider;
